import { useFormContext, Controller } from "react-hook-form";

import Box from "ds/components/Box";
import FullScreenModalBody from "ds/components/FullScreenModal/Body";
import FullScreenModalBodyHeader from "ds/components/FullScreenModal/BodyHeader";
import useTypedContext from "hooks/useTypedContext";
import { ScanFormFields } from "shared/Scan/types";

import DefinedRegionsCard from "./DefinedRegionsCard";
import ResourceTypesField from "./ResourceTypesField";
import { NewScanScheduleContext } from "../../context";
import { SCHEDULE_SCAN_WIZARD_STEP_HEADERS } from "../../constants";
import { NewScanScheduleStep } from "../../types";

const NewScanScheduleStepDefineScope = () => {
  const { control, watch } = useFormContext<ScanFormFields>();
  const {
    goToStep,
    formOptions: { regions: regionOptions, resourceTypes: resourceTypeOptions },
  } = useTypedContext(NewScanScheduleContext);

  const regions = watch("regions");

  return (
    <FullScreenModalBody zeroMinHeight>
      <FullScreenModalBodyHeader
        {...SCHEDULE_SCAN_WIZARD_STEP_HEADERS[NewScanScheduleStep.DefineScope]}
      />
      <Box direction="column" gap="large" grow="1" zeroMinHeight>
        <DefinedRegionsCard
          regions={regions}
          regionOptions={regionOptions}
          onEditRegions={() => goToStep(NewScanScheduleStep.AttachProviders)}
        />

        <Controller
          name="resourceTypes"
          control={control}
          rules={{ validate: (value) => value.length > 0 || "Select at least one resource type." }}
          render={({ field, fieldState }) => (
            <ResourceTypesField
              value={field.value}
              onChange={field.onChange}
              options={resourceTypeOptions}
              error={fieldState.error?.message}
            />
          )}
        />
      </Box>
    </FullScreenModalBody>
  );
};

export default NewScanScheduleStepDefineScope;
